import React from 'react';
import styles from './index.module.scss';

const MobileAboutUsMain = () => {
  return (
    <section className={styles['lei-slideinfo']}>
      <div className={styles['lei-info1']}>
        <div className={styles['lei-slideinfo-info']}>
          <div className={styles['lei-slideinfo-title']}>
            <h2>关于我们</h2>
            <p></p>
            <div style={{ textAlign: 'left', textIndent: '2em' }}>
              成都雷石天地电子技术有限公司是一家专业级家庭K歌产品和服务的提供商。
              作为全场景音乐科技的探索者，雷石团队深耕音乐产业27年，产品在车载、商用、家用、闲时碎片化娱乐等多元化场景应用广泛。
              作为雷石家庭线产品的开拓者，成都雷石主攻电视大屏K歌、K歌音响等家用市场，专注于家庭互联网K歌平台和应用的开发及运营，致力于让专业级K歌走入千家万户。
              旗下K歌产品已实现OTT智能终端全覆盖，用户遍布全国。旗下专业K歌平台为众多知名音响厂商提供一站式智能化解决方案，并与各大品牌音响厂商联合推出多款专业级家庭K歌设备，让用户足不出户即可享受专业的K歌服务和沉浸式K歌体验。
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileAboutUsMain;
